import { Accordion, AccordionTab } from 'primereact/accordion'
import { useEffect, useRef, useState } from 'react';
import { Api } from '../../../../services/api';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputNumber } from 'primereact/inputnumber';
import { useFormik } from 'formik';
import { Toast } from 'primereact/toast';
import { BiCheck } from 'react-icons/bi';
import { Dropdown } from 'primereact/dropdown';


const PmOverallJobPerformance = ({ userData }) => {
    const [ProjectData, setProjectData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const columns = [
        { key: 'targetGp', label: 'ID' },
        { key: 'percentageCompletion', label: 'Name' },
        { key: 'costPerSF', label: 'Age' },

    ];
    const [tableColumns, setTableColumns] = useState(columns);
    const [tableColumnsForMonthly, setTableColumnsForMonthly] = useState(columns);
    const [projectManager, setProjectManager] = useState('');
    const [monthlyClientRating, setMonthlyClientRating] = useState([]);
    const [monthlyClientModals, setMonthlyClientModals] = useState(false);
    const [projectAndActual, setProjectAndActual] = useState([]);
    const [isShow, setIsShow] = useState(false);
    const [selectMonth, setSelectMonth] = useState('Jan');
    const [monthList, setMonthList] = useState(['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']);


    const [roleId, setRoleId] = useState('');

    const toast = useRef(null);

    //* -----------------------------------------
    useEffect(() => {
        const role_id = localStorage.getItem('role_id');
        setRoleId(role_id);
        // getProjectDetails(role_id);

        if (userData == undefined) {
            var user_id = localStorage.getItem('user_id');
            getProjectDetails(role_id, user_id);


        } else {
            const [parsedType, parsedUId, parsedRId, first_name, last_name] = userData.split('-');
            getProjectDetails(parsedRId, parsedUId);
        }


        return () => {
            // Cleanup tasks before the component is unmounted
        };
    }, []);



    const getProjectDetails = (role_id, user_id) => {

        var _body = {
            userId: user_id,
            role_id: role_id,
            year: new Date().getFullYear()
        }
        const token = localStorage.getItem('authToken');

    // Create headers with token if it exists
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : ''
    };
        fetch(Api.API_BASE_URL + 'performance-huddle/overall-job-performance', {
            method: "POST",
            headers:headers,

            body: JSON.stringify(_body),
        })
            .then((response) => response.json())
            .then((response) => {

                setIsLoading(false);
                setProjectData(response.result);
                setProjectManager(response.pM);
                setProjectAndActual(response.actuals);
                setIsShow(response.isShow);

                var t = [];
                var r = [];

                for (let index = 0; index <= response.countAllResult; index++) {
                    t.push(index)
                    r.push(index)
                }
                setTableColumns(t);
                r.push('d')

                var s = [];

                for (let index = 0; index <= response.countAllResultForMotnlyCilentRatingAndActuals; index++) {
                    s.push(index)
                }
                s.push('d')
                setTableColumnsForMonthly(s);
                setMonthlyClientRating(response.monthlyClient);
            })
            .catch((error) => {
                setIsLoading(false);

            });
    }

    //* -----------------------------------------------
    const formik = useFormik({
        initialValues: {
            projectname: '',
            year: new Date().getFullYear(), // Default to current year
            JanRating: '0',
            FebRating: '0',
            MarRating: '0',
            AprRating: '0',
            MayRating: '0',
            JunRating: '0',
            JulRating: '0',
            AugRating: '0',
            SepRating: '0',
            OctRating: '0',
            NovRating: '0',
            DecRating: '0',
            clientsComments: '',
            vpComments: '',
            JanClientComment: "",
            FebClientComment: "",
            MarClientComment: "",
            AprClientComment: "",
            MayClientComment: "",
            JunClientComment: "",
            JulClientComment: "",
            AugClientComment: "",
            SepClientComment: "",
            OctClientComment: "",
            NovClientComment: "",
            DecClientComment: "",
            JanvpComments: "",
            FebvpComments: "",
            MarvpComments: "",
            AprvpComments: "",
            MayvpComments: "",
            JunvpComments: "",
            JulvpComments: "",
            AugvpComments: "",
            SepvpComments: "",
            OctvpComments: "",
            NovvpComments: "",
            DecvpComments: "",
        },


        onSubmit: (data) => {
            var url = Api.API_BASE_URL + 'performance-points/performance-points-save-monthly-ratting';
            const token = localStorage.getItem('authToken');

            // Create headers with token if it exists
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': token ? `Bearer ${token}` : ''
            };

            fetch(url, {
                method: "POST",
                headers: headers,
                body: JSON.stringify(data),
            })
                .then((response) => response.json())
                .then((Josn) => {
                    if (Josn.error != '') {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });
                    } else {
                        setMonthlyClientModals(false);
                        // getProjectDetails();
                        toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });
                        if (userData == undefined) {
                            var user_id = localStorage.getItem('user_id');
                            const role_id = localStorage.getItem('role_id');
                            getProjectDetails(role_id, user_id);


                        } else {
                            const [parsedType, parsedUId, parsedRId, first_name, last_name] = userData.split('-');
                            getProjectDetails(parsedRId, parsedUId);
                        }
                    }

                })
                .catch((error) => {
                    console.error("Error:", error);
                });

        }
    });


    //* ----------------------

    //! ---------------------

    const headerStyle = {
        background: "#dddddd",
        border: "1px solid #E9ECEF",
        textAlign: "center",
    };

    const cellStyle = {

        borderLeft: "2px solid #E9ECEF",
        textAlign: "center",
        border: '1px solid white'
    };

    const cellStylea = {
        borderLeft: "2px solid #E9ECEF",
        textAlign: "start",
        // padding: "5px",
        border: '1px solid white',

    };


    //* -----------------------------------------------
    const renderInputArea = (fieldName, title) => (
        <div className="col-3 p-2">
            <label className='Leads-heading' >{title}</label>
            <InputNumber
                id={fieldName}
                name={fieldName}

                value={formik.values[fieldName]}
                onChange={(e) => {
                    formik.setFieldValue(fieldName, e.value)
                }}
            />
        </div>
    );

    const renderTextArea = (fieldName, title) => (
        <div className="col-12 p-2">
            <label className='Leads-heading' >{title}</label>
            <textarea
                name={fieldName}
                id={fieldName}
                value={formik.values[fieldName]}
                onChange={(e) => {
                    formik.setFieldValue(fieldName, e.target.value)
                }}
                rows={5} // Increase height using rows
                style={{ width: '100%', boxSizing: 'border-box', border: '0.5px solid #DDDFE2', borderRadius: '4px', outline: 'none', color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px' }}
            ></textarea>
        </div>
    );

    const renderDropdown = () => (
        <div className="col-12 p-2" >
            <label className='Leads-heading' >Month</label>
            <Dropdown
                optionValue='id'
               
                placeholder={`select month`}
                options={monthList}
               
                value={selectMonth}

                onChange={(e) => {
                    console.log('sses', e.target.value)
                    setSelectMonth(e.target.value)}}
                style={{ width: '100%', boxSizing: 'border-box', border: '0.5px solid #DDDFE2', borderRadius: '4px', outline: 'none',color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px' }}
            />
        </div>
    );

    //* -----------------------------------------------

    const priceBodyTemplatee = (rowData) => {
        if (rowData === '') {
            return '';
        }
        let numberValue = Number(rowData);
        // Ensure rowData is a number after the conversion and it's not NaN
        if (isNaN(numberValue)) {
            return '';
        }

        // return  numberValue.toFixed(2) + '%';
        const isNegative = rowData < 0; // Check if the value is negative

        return (
            <span style={{ color: isNegative ? "red" : "black" }}>
                {formatCurrency(rowData)}
                {/* $ {numberValue.toFixed(2) } */}
            </span>
        );
    };

    const formatCurrency = (value) => {
        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };


    const handleButtonClick = (data) => {
        console.log("data", data);

        const originalString = data;
        console.log("originalString", originalString);
        let text = originalString.replace(/\([^)]+\)/g, "");
        console.log(text.trim());

        //* -----------------------
        var url = Api.API_BASE_URL + 'performance-points/performance-points-get-monthly-ratting';

        var body = {
            projectName: text.trim(),
            year: formik.values.year
        }
        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };
        fetch(url, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(body),
        })
            .then((response) => response.json())
            .then((Josn) => {
                if (Josn.error != '') {
                } else {

                    formik.setFieldValue('projectname', Josn.projectName);
                    formik.setFieldValue('JanRating', Josn.JanRating);
                    formik.setFieldValue('FebRating', Josn.FebRating);
                    formik.setFieldValue('MarRating', Josn.MarRating);
                    formik.setFieldValue('AprRating', Josn.AprRating);
                    formik.setFieldValue('MayRating', Josn.MayRating);
                    formik.setFieldValue('JunRating', Josn.JunRating);
                    formik.setFieldValue('JulRating', Josn.JulRating);
                    formik.setFieldValue('AugRating', Josn.AugRating);
                    formik.setFieldValue('SepRating', Josn.SepRating);
                    formik.setFieldValue('OctRating', Josn.OctRating);
                    formik.setFieldValue('NovRating', Josn.NovRating);
                    formik.setFieldValue('DecRating', Josn.DecRating);
                    formik.setFieldValue('clientsComments', Josn.clientsComments);
                    formik.setFieldValue('vpComments', Josn.vpComments);
                    formik.setFieldValue('JanClientComment', Josn.JanClientComment);
                    formik.setFieldValue('FebClientComment', Josn.FebClientComment);
                    formik.setFieldValue('MarClientComment', Josn.MarClientComment);
                    formik.setFieldValue('AprClientComment', Josn.AprClientComment);
                    formik.setFieldValue('MayClientComment', Josn.MayClientComment);
                    formik.setFieldValue('JunClientComment', Josn.JunClientComment);
                    formik.setFieldValue('JulClientComment', Josn.JulClientComment);
                    formik.setFieldValue('AugClientComment', Josn.AugClientComment);
                    formik.setFieldValue('SepClientComment', Josn.SepClientComment);
                    formik.setFieldValue('OctClientComment', Josn.OctClientComment);
                    formik.setFieldValue('NovClientComment', Josn.NovClientComment);
                    formik.setFieldValue('DecClientComment', Josn.DecClientComment);
                    formik.setFieldValue('JanvpComments', Josn.JanvpComments);
                    formik.setFieldValue('FebvpComments', Josn.FebvpComments);
                    formik.setFieldValue('MarvpComments', Josn.MarvpComments);
                    formik.setFieldValue('AprvpComments', Josn.AprvpComments);
                    formik.setFieldValue('MayvpComments', Josn.MayvpComments);
                    formik.setFieldValue('JunvpComments', Josn.JunvpComments);
                    formik.setFieldValue('JulvpComments', Josn.JulvpComments);
                    formik.setFieldValue('AugvpComments', Josn.AugvpComments);
                    formik.setFieldValue('SepvpComments', Josn.SepvpComments);
                    formik.setFieldValue('OctvpComments', Josn.OctvpComments);
                    formik.setFieldValue('NovvpComments', Josn.NovvpComments);
                    formik.setFieldValue('DecvpComments', Josn.DecvpComments);

                    setMonthlyClientModals(true);
                }

            })
            .catch((error) => {
                console.log("Error:", error);
            });


        //* -----------------------



    };
    
    const renderYearDropdown = () => {
        const years = Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i); // Last 10 years
    
        return (
            <Dropdown 
                value={formik.values.year} 
                options={years.map(year => ({ label: year.toString(), value: year }))}
                onChange={(e) => formik.setFieldValue('year', e.value)}
                placeholder="Select Year"
            />
        );
    };    

    const formatValue = (value) => {
        return value == 0 ? '' : value;
    }

    const formatHeaderText = (text) => {
        return text.replace(/\(([^)]+)\)/g, '<br><span style="color: white; font-size: 12px;">($1)</span>');
    };    

    return (
        <>
            <div className="">
                <Toast ref={toast} />
                <form >
                    {userData == undefined ? (<div className="flex d-flex justify-content-end top-button submitbutton " style={{ position: 'sticky', top: '47px', zIndex: 999, backgroundColor: '#f8f9fa', padding: '5px 15px', borderBottom: '1px solid #ddd', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                        <Button type="submit" title='Save the OVERALL JOB PERFORMANCE' style={{ cursor: 'pointer' }} className="customSave-button m-2" >
                            <div className='flex items-center gap-2 px-1 ' style={{ alignItems: 'center' }}>
                                <BiCheck size={22} />
                                <span> SAVE </span>
                            </div>
                        </Button>
                    </div>) : (<div></div>)}

                    <div className="cardd" style={{ border: 'none', margin: 0, padding: 0, minHeight: '82vh' }}>
                        <div className=" gap-2 mb-3" >
                            {isLoading ? (
                                <div className="loading-spinner">
                                    Loading...
                                    <div className="spinner"></div>
                                </div>
                            ) : (
                                <Accordion multiple activeIndex={[0, 1, 2]}>

                                    <AccordionTab header="Action Steps" className="p-2">

                                        <div className="table-container form-bg" style={{ overflowX: "auto" }}>
                                            <table style={{ borderCollapse: "collapse", width: "auto" }}>
                                                <thead>
                                                    {/* Use first row of ProjectData as table headers */}
                                                    {ProjectData.length > 0 && (
                                                        <tr>
                                                            {tableColumns.map((column, columnIndex) => (
                                                                <th 
                                                                    key={"header_" + columnIndex} 
                                                                    style={{ 
                                                                        ...headerStyle, 
                                                                        minWidth: columnIndex === 0 ? "400px" : "200px", 
                                                                        textAlign: columnIndex === 0 ? "left" : "center",
                                                                        padding: "4px 8px", height: "24px", lineHeight: "1.2" 
                                                                    }}
                                                                >
                                                                    {ProjectData[0]['rowKey_' + columnIndex] || "N/A"}
                                                                </th>
                                                            ))}
                                                        </tr>
                                                    )}
                                                </thead>

                                                <tbody>
                                                    {ProjectData.slice(1).map((row, rowIndex) => ( // Skip the first row
                                                        <tr key={"action_step" + rowIndex}>
                                                            {tableColumns.map((column, columnIndex) => {
                                                                const cellValue = row['rowKey_' + columnIndex] || "-";
                                                                
                                                                // Apply conditional styling for "YES" and "NO"
                                                                const cellStyleWithCondition = {
                                                                    ...cellStyle,
                                                                    minWidth: columnIndex === 0 ? "400px" : "200px",
                                                                    textAlign: columnIndex === 0 ? "left" : "center",
                                                                    // backgroundColor: cellValue === "YES" ? "#d4edda" : cellValue === "NO" ? "#f8d7da" : "transparent",
                                                                    color: cellValue === "YES" ? "#00d26a" : cellValue === "NO" ? "#ff0000" : "inherit",
                                                                    // fontWeight: "bold",
                                                                    borderRadius: "5px",
                                                                    padding: "5px",  
                                                                    padding: "4px 8px", height: "24px", lineHeight: "1.2"                                                                   
                                                                };

                                                                // Display icons for YES/NO
                                                                const formattedValue =
                                                                    // cellValue === "YES" ? "✅" :
                                                                    // cellValue === "NO" ? "❌" :
                                                                    cellValue; // Default value

                                                                return (
                                                                    <td 
                                                                        key={"row_" + rowIndex + "_col_" + columnIndex} 
                                                                        style={cellStyleWithCondition}
                                                                    >
                                                                        {formattedValue}
                                                                    </td>
                                                                );
                                                            })}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>

                                    </AccordionTab>

                                    <AccordionTab header="Monthly Client Rating" className='p-2 '>
                                        <div className="table-container form-bg" style={{ overflowX: "auto" }}>
                                            <table style={{ borderCollapse: "collapse", width: "auto" }}>

                                                {monthlyClientRating.map((row, rowIndex) => rowIndex == 0 ? (


                                                    <tr key={"monthlyClientRating" + rowIndex} >
                                                        {tableColumnsForMonthly.map((column, columnIndex) => (
                                                            // <th style={{ ...headerStyle, minWidth: "150px" }}>
                                                                            
                                                            <th style={{ ...headerStyle, minWidth: "200px", padding: "4px 8px", height: "24px", lineHeight: "1.2"}}  >
                                                                

                                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                                    {/* Button at the top */}
                                                                    {isShow && columnIndex !== 0 && columnIndex !== 1 ? (
                                                                        <Button 
                                                                            icon="pi pi-plus" 
                                                                            type="button" 
                                                                            style={{ width: '20px', height: '20px', color: 'white' }} 
                                                                            rounded 
                                                                            outlined
                                                                            onClick={(e) => handleButtonClick(row['rowKey_' + columnIndex])}
                                                                            className="mb-1" // Added margin-bottom for spacing
                                                                        />
                                                                    ) : null}

                                                                    {/* Text below the button */}
                                                                    {/* <span>{row['rowKey_' + columnIndex]}</span> */}
                                                                    <span dangerouslySetInnerHTML={{ __html: formatHeaderText(row['rowKey_' + columnIndex]) }} />
                                                                </div>

                                                            </th>
                                                        ))}

                                                    </tr>

                                                ) : (
                                                    <tr key={"monthlyClientRating" + rowIndex}>
                                                        {tableColumnsForMonthly.map((column, columnIndex) => {
                                                            const cellValue = formatValue(row['rowKey_' + columnIndex]); // Get formatted value

                                                            // Check if cellValue is a number and greater than 5
                                                            const isGreaterThanFive = !isNaN(cellValue) && Number(cellValue) > 7;

                                                            // Define dynamic cell style
                                                            const dynamicCellStyle = {
                                                                // backgroundColor: isGreaterThanFive ? "#d4edda" : "transparent", // Light green if > 5
                                                                color: isGreaterThanFive ? "#00d26a" : "#ff0000", // Dark green text for contrast
                                                                minWidth: "200px",
                                                                ...cellStyle, // Keep other styles
                                                                minWidth: "200px", padding: "4px 8px", height: "24px", lineHeight: "1.2"
                                                            };

                                                            return columnIndex === 0 ? (
                                                                monthlyClientRating.length - 1 === rowIndex ? (
                                                                    <th style={{ ...headerStyle, minWidth: "200px", padding: "4px 8px", height: "24px", lineHeight: "1.2" }}>
                                                                        {row['rowKey_' + columnIndex]}
                                                                    </th>
                                                                ) : (
                                                                    <th style={{ ...cellStylea, minWidth: "200px", padding: "4px 8px", height: "24px", lineHeight: "1.2" }}>
                                                                        {row['rowKey_' + columnIndex]}
                                                                    </th>
                                                                )
                                                            ) : (
                                                                monthlyClientRating.length - 1 === rowIndex ? (
                                                                    <th style={{ ...headerStyle, minWidth: "200px" }}>
                                                                        {cellValue}
                                                                    </th>
                                                                ) : (
                                                                    <th style={dynamicCellStyle}>
                                                                        {cellValue}
                                                                    </th>
                                                                )
                                                            );
                                                        })}
                                                    </tr>


                                                ))}

                                                    <Dialog
                                                        header="MONTHLY CLIENT RATING"
                                                        headerClassName="centered-header p-3 font-bold text-lg bg-gray-400 text-gray-800 rounded-t"
                                                        visible={monthlyClientModals}
                                                        maximizable
                                                        style={{ width: "50vw", maxWidth: "600px" }}
                                                        dismissableMask={true}
                                                        onHide={() => setMonthlyClientModals(false)}
                                                    >
                                                        <div className="w-full p-5 bg-gray-100 rounded-b">
                                                            <form onSubmit={formik.handleSubmit}>
                                                                {/* Project Name & Year */}
                                                                <div className="mb-4 text-center">
                                                                    <h3 className="text-lg font-bold text-gray-800">{formik.values.projectname}</h3>
                                                                    <div className="mt-2">{renderYearDropdown()}</div>
                                                                </div>

                                                                {/* Monthly Ratings */}
                                                                <fieldset className="p-4 bg-white rounded-lg shadow-md">
                                                                    <legend className="text-sm font-bold text-gray-700 px-2">Monthly Ratings</legend>
                                                                    <div className="grid grid-cols-2 gap-3 mt-2">
                                                                        {renderInputArea("JanRating", "January")}
                                                                        {renderInputArea("FebRating", "February")}
                                                                        {renderInputArea("MarRating", "March")}
                                                                        {renderInputArea("AprRating", "April")}
                                                                        {renderInputArea("MayRating", "May")}
                                                                        {renderInputArea("JunRating", "June")}
                                                                        {renderInputArea("JulRating", "July")}
                                                                        {renderInputArea("AugRating", "August")}
                                                                        {renderInputArea("SepRating", "September")}
                                                                        {renderInputArea("OctRating", "October")}
                                                                        {renderInputArea("NovRating", "November")}
                                                                        {renderInputArea("DecRating", "December")}
                                                                    </div>
                                                                </fieldset>

                                                                {/* Additional Comments */}
                                                                <fieldset className="p-4 bg-white rounded-lg shadow-md mt-4">
                                                                    <legend className="text-sm font-bold text-gray-700 px-2">Additional Comments</legend>
                                                                    <div className="space-y-3">
                                                                        {renderDropdown()}
                                                                        {renderTextArea(`${selectMonth}ClientComment`, "CLIENTS COMMENTS")}
                                                                        {renderTextArea(`${selectMonth}vpComments`, "VP CONSTRUCTION OPS COMMENTS ONLY")}
                                                                    </div>
                                                                </fieldset>

                                                                {/* Save Button */}
                                                                <div className="sticky bottom-0 bg-white p-3 flex justify-center">
                                                                    <Button label="SAVE" type="submit" className="customSave-button" />
                                                                </div>
                                                            </form>
                                                        </div>
                                                    </Dialog>




                                            </table>


                                        </div>

                                    </AccordionTab>




                                    {roleId != 18 && (
                                        <AccordionTab header="Projections & Actuals" className='p-2 '>
                                            <div className="table-container form-bg" style={{ overflowX: "auto" }}>
                                                <table style={{ borderCollapse: "collapse", width: "auto" }}>
                                                    {projectAndActual.map((row, rowIndex) => rowIndex == 0 ? (

                                                        <tr>
                                                            {tableColumnsForMonthly.map((column, columnIndex) => (

                                                                <th style={{ ...headerStyle, minWidth: "200px", padding: "4px 8px", height: "24px", lineHeight: "1.2" }}  >{row['rowKey_' + columnIndex]}</th>
                                                            ))}

                                                        </tr>

                                                    ) : (

                                                        <tr >
                                                            {tableColumnsForMonthly.map((column, columnIndex) => columnIndex == 0 ? (

                                                                <th style={{ ...cellStyle, minWidth: "200px", padding: "4px 8px", height: "24px", lineHeight: "1.2" }}  >{row['rowKey_' + columnIndex]}</th>
                                                            ) : (

                                                                <td style={{ ...cellStyle, minWidth: "200px", padding: "4px 8px", height: "24px", lineHeight: "1.2" }}  >{priceBodyTemplatee(row['rowKey_' + columnIndex])}</td>
                                                            ))}

                                                        </tr>

                                                    ))}
                                                </table>


                                            </div>

                                        </AccordionTab>
                                    )}

                                </Accordion>
                            )}
                        </div>
                    </div>
                </form>
            </div>
        </>
    )
}

export default PmOverallJobPerformance